import { render } from "./HeaderDesktop.vue?vue&type=template&id=e981cd26&scoped=true"
import script from "./HeaderDesktop.vue?vue&type=script&lang=js"
export * from "./HeaderDesktop.vue?vue&type=script&lang=js"

import "./HeaderDesktop.vue?vue&type=style&index=0&id=e981cd26&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e981cd26"]])

export default __exports__